import React from 'react';

export const FireSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="50"
      viewBox="0 0 49 50"
      fill="none"
    >
      <g clip-path="url(#clip0_16507_67212)">
        <path
          d="M17.8022 16.0761C17.1384 17.8652 16.1474 21.0808 16.8606 22.7536C16.8606 22.7536 17.3065 19.0491 23.079 15.798C25.4031 14.4893 26.4855 12.1523 26.3351 10.1417C26.2489 9.00247 25.8123 7.96345 25.3937 7.20747C25.1503 6.76372 25.566 6.2507 26.0523 6.40367C28.993 7.33397 33.595 9.45352 34.2663 15.1463C34.5609 17.6451 34.0021 19.9962 32.9377 22.2539C32.26 23.6964 30.3915 26.8063 32.4842 27.8103C33.9776 28.5275 35.0731 27.4816 35.6552 26.6735C35.8974 26.3372 36.4145 26.3755 36.6 26.7455C38.4467 30.4788 37.7195 34.0983 36.3492 37.0149C33.6998 42.6525 26.547 45.3558 20.5884 43.7592C13.1448 41.7647 8.36067 35.9179 8.88994 27.7969C9.10503 24.519 11.0689 18.4454 17.0331 15.3847C17.4766 15.1541 17.9815 15.6 17.8022 16.0761Z"
          fill="url(#paint0_radial_16507_67212)"
        />
        <path
          d="M27.0757 30.4305C25.2782 26.1636 27.5865 22.4631 28.6899 21.0376C28.8371 20.8505 28.649 20.5866 28.424 20.6654C27.0286 21.1521 24.1045 22.3939 22.266 24.7515C19.7784 27.9381 19.4155 29.727 19.7422 32.118C19.9385 33.5586 19.2341 33.6642 18.9042 33.6276C18.5833 33.5934 18.3546 33.3121 18.1856 33.0371C17.7019 32.2373 17.4506 31.3186 17.4601 30.3839C17.462 30.1838 17.2312 30.067 17.0783 30.191C15.9201 31.1327 14.9801 32.8899 14.6039 34.2094C13.44 38.2878 15.934 42.5148 20.0271 43.6115C25.1858 44.9938 30.4725 40.2958 28.7862 34.7323C28.298 33.1132 27.7325 31.9879 27.0757 30.4305Z"
          fill="url(#paint1_radial_16507_67212)"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_16507_67212"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.089 43.4581) rotate(-164.751) scale(22.0586 36.1938)"
        >
          <stop offset="0.314" stop-color="#FF9800" />
          <stop offset="0.662" stop-color="#FF6D00" />
          <stop offset="0.972" stop-color="#F44336" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_16507_67212"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(25.9678 22.5756) rotate(105.579) scale(23.0801 17.3695)"
        >
          <stop offset="0.214" stop-color="#FFF176" />
          <stop offset="0.328" stop-color="#FFF27D" />
          <stop offset="0.487" stop-color="#FFF48F" />
          <stop offset="0.672" stop-color="#FFF7AD" />
          <stop offset="0.793" stop-color="#FFF9C4" />
          <stop offset="0.822" stop-color="#FFF8BD" stop-opacity="0.804" />
          <stop offset="0.863" stop-color="#FFF6AB" stop-opacity="0.529" />
          <stop offset="0.91" stop-color="#FFF38D" stop-opacity="0.209" />
          <stop offset="0.941" stop-color="#FFF176" stop-opacity="0" />
        </radialGradient>
        <clipPath id="clip0_16507_67212">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(10.3633 0.904297) rotate(15)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
